import { z } from 'zod';

import { zodSuccessResponseSchema } from '../validations';

export const zodBulkApproveDlnItemsItemSchema = z.object({
  acceptedQuantityFactor: z.number().min(0).max(1).nullable(),
  itemId: z.number().int().min(0),
});

export const zodBulkApproveDlnItemsBodySchema = z.object({
  items: z.array(zodBulkApproveDlnItemsItemSchema),
});

export const zodBulkApproveDlnItemsEndpointSchema = z.tuple([
  z.literal('delivery_note'),
  z.uuid(),
  z.literal('item'),
  z.literal('bulk'),
  z.literal('approve'),
]);

export { zodSuccessResponseSchema };
